import { Reducer } from 'redux';
import { IOffersDashboardFilterOptions, offersDashboardActionTypes, OffersDashboardState } from './types';
import { GroupedCustomTabs } from '@/components/pages/offers-dashboard/types';
import { defaultTab } from '@/store/offers-dashboard/types';
import { ApplyActionTypes } from '../apply/types';

const defaultFilterOptions: IOffersDashboardFilterOptions = {
  courses: [],
  nationality: [],
  residence: [],
  applicationCountry: [],
  feeStatus: [],
  tags: [],
  offerStatus: [],
};

const initialState: OffersDashboardState = {
  dashboardRows: [],
  dashboardRowsLoaded: false,

  stageTotals: { offerTotals: [], applicationTotals: [] },
  allTotalsLoaded: false,

  resetDropdownStatus: false,
  isDropdownDisabled: false,
  isTaskBarOpened: false,

  customTabs: undefined,
  dashboardTabs: undefined,
  tabs: [],
  tabsLoaded: false,
  currentTab: defaultTab as string,

  filters: [],
  isFiltersVisible: false,

  sort: undefined,
  selectedRows: [],
  allSelected: false,
  filterOptionsLoaded: false,
  filterOptions: defaultFilterOptions,
};

const reducer: Reducer<OffersDashboardState> = (state = initialState, action) => {
  switch (action.type) {
    /**
     * Lead operations
     */
    case offersDashboardActionTypes.CLEAR_DASHBOARD_ROWS: {
      return {
        ...state,
        dashboardRows: [],
        dashboardRowsLoaded: false,
      };
    }
    case offersDashboardActionTypes.GET_DASHBOARD_ROWS: {
      return {
        ...state,
        dashboardRows: [],
        dashboardRowsLoaded: false,
      };
    }
    case offersDashboardActionTypes.GET_DASHBOARD_ROWS_SUCCESS: {
      const { rows } = action.payload;
      return {
        ...state,
        dashboardRows: rows,
        dashboardRowsLoaded: true,
      };
    }
    case offersDashboardActionTypes.GET_DASHBOARD_ROWS_FAILURE: {
      const { e } = action.payload;
      console.error(e);
      return {
        ...state,
        dashboardRows: [],
        dashboardRowsLoaded: false,
      };
    }

    /**
     * Total operations
     */
    case offersDashboardActionTypes.CLEAR_TOTALS: {
      return {
        ...state,
        stageTotals: { offerTotals: [], applicationTotals: [] },
        allTotalsLoaded: false,
      };
    }
    case offersDashboardActionTypes.GET_TOTALS: {
      return {
        ...state,
        stageTotals: { offerTotals: [], applicationTotals: [] },
        allTotalsLoaded: false,
      };
    }
    case offersDashboardActionTypes.GET_TOTALS_SUCCESS: {
      const { totals: stageTotals } = action.payload;
      return {
        ...state,
        stageTotals,
        allTotalsLoaded: true,
      };
    }
    case offersDashboardActionTypes.GET_TOTALS_FAILURE: {
      const error = action.payload.e;
      console.error(error);
      return {
        ...state,
        stageTotals: { offerTotals: [], applicationTotals: [] },
        allLeadsLoaded: false,
      };
    }

    /**
     * Other operations
     */

    case offersDashboardActionTypes.SET_FILTERS: {
      return {
        ...state,
        filters: action.payload.filters,
      };
    }

    case offersDashboardActionTypes.SET_SORT: {
      return {
        ...state,
        sort: action.payload,
      };
    }

    case offersDashboardActionTypes.SET_FILTERS_VISIBLE: {
      return {
        ...state,
        isFiltersVisible: action.payload.isFiltersVisible,
      };
    }

    case offersDashboardActionTypes.SET_IS_TASKBAR_OPEN: {
      return {
        ...state,
        isTaskBarOpened: action.payload.isOpen,
      };
    }

    case offersDashboardActionTypes.SET_IS_DROPDOWN_DISABLED: {
      return {
        ...state,
        isDropdownDisabled: action.payload.isDisabled,
      };
    }

    case offersDashboardActionTypes.SET_CUSTOM_TABS: {
      const customTabs: GroupedCustomTabs = action.payload.tabs;
      const tabs = Object.keys(customTabs).reduce((prev, key) => {
        return [...prev, ...customTabs[key]];
      }, []);
      return {
        ...state,
        customTabs,
        tabs,
        tabsLoaded: true,
        allSelected: false,
      };
    }

    case offersDashboardActionTypes.SWITCH_TAB: {
      return {
        ...state,
        currentTab: action.payload.tabs,
      };
    }

    case offersDashboardActionTypes.GET_FILTERS: {
      return { ...state, filterOptionsLoaded: false };
    }

    case offersDashboardActionTypes.GET_FILTERS_SUCCESS: {
      return { ...state, filterOptions: action.payload, filterOptionsLoaded: true };
    }

    case offersDashboardActionTypes.GET_FILTERS_FAILURE: {
      const error = action.payload.e;
      console.error(error);
      return { ...state, filterOptions: undefined, filterOptionsLoaded: false };
    }

    case offersDashboardActionTypes.SET_SELECTED_ROWS: {
      return {
        ...state,
        selectedRows: action.payload.selectedRows,
        allSelected: false,
      };
    }

    case offersDashboardActionTypes.SELECT_ALL: {
      return { ...state, allSelected: action.payload };
    }
    case ApplyActionTypes.STUDENTS_TAGS_UNPIN_SUCCESS: {
      const tagIdToUnpin = action.payload?.tag?.id;
      const applicantIdToUnpinFrom = action.payload?.applicantId;

      const dashboardRows = state.dashboardRows.map(row =>
        row.offerId === action.payload?.offerId && row.userId === applicantIdToUnpinFrom
          ? {
              ...row,
              tags: row.tags?.filter(tag => {
                return tag.id !== tagIdToUnpin;
              }),
            }
          : row,
      );
      return {
        ...state,
        dashboardRows,
      };
    }

    default:
      return state;
  }
};

export { reducer as offersDashboardReducer };
